<template lang="pug">
.arrow-btn
  .copy {{ copy }}
  .arrow
    arrow-gray
  
</template>
<script>
import ArrowGray from '@/components/wedgits/ArrowGray'
import { mapMutations } from 'vuex'
export default {
  name: 'ArrowBtn',
  components: { ArrowGray },
  props: {
    copy: {},
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.arrow-btn
  display: flex
  align-items: center
  .copy
    font-size: pxToRem(30)
    color: #999999
    line-height: 0
  .arrow
    width: pxToRem(36)
    height: pxToRem(36)
</style>
